import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const cqInstance = axios.create({
    baseURL: `${process.env.REACT_APP_QUALITY_CERTIFICATE_URL}`,
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_QUALITY_CERTIFICATE_API_KEY
    }
})


const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))

export default {
    getPurchaseOrderData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/search/purchase',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getSalesOrderData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/search/salesOrder',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getInvoiceData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/search/invoice',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getIppnData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/search/ippn',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getValidData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/search/valid',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getSotData: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            'search/sot',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    getReservationData: (idToken, data) => new Promise((resolve, reject) => {
        console.log('getreservationdata' + data)
        instance.post(
            'search/reservation',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    downloadDocument: (id) => new Promise((resolve, reject) => {
        const formatedId = id.indexOf('.') !== -1 ? id.substring(0, id.indexOf('.')) : id;
        cqInstance.post(
            'document/get-certificate',
            {
                'id': formatedId
            }
        ).then(response => {
            if (response.status === 200) {
                console.log(response)
                resolve(response)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
            .catch(error => {
                reject(error)
            })
    }),

    // getClient: (idToken) => new Promise((resolve, reject) => {
    //     instance.post(
    //         '/search/client',
    //         {},
    //         {
    //             headers: {
    //                 Authorization: formatAuthorization(idToken)
    //             }
    //         }
    //     ).then(response => {
    //         if (response.status === 200) {
    //             resolve(response.data)
    //         }
    //         else {
    //             reject(new Error('Couldn\'t retrieve data'))
    //         }
    //     })
    //         .catch(error => {
    //             reject(error)
    //         })
    // })
}
